export const RoleConstant = {
  sysAdmin: 'SysAdmin',
  jrSiteInspector: 'JrSiteInspector',
  srSiteInspector: 'SrSiteInspector',
  regionReviewer:'RegionReviewer'
}
